import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MapService } from 'src/app/services/map.service';
import { ip } from 'src/app/constant/constant';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-content-creator-detail',
  templateUrl: './content-creator-detail.component.html',
  styleUrls: ['./content-creator-detail.component.scss'],
  standalone: false
})
export class ContentCreatorDetailComponent
  implements OnInit, AfterViewInit, OnDestroy {
  creatorDetailsForm: FormGroup;
  selectedGameImage: any;
  uploadContainerHeight: string = '300px';
  params: string = 'details';
  contentId: string = null;
  contentData: any = null;
  ip: any = ip;
  mapCode: any;
  coordsPass: any;

  contentImgArr: any[] = [];
  constructor(
    private mapService: MapService,
    private elementRefTwo: ElementRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private currentUserService: CurrentUserService,
    private cdr: ChangeDetectorRef,
  ) { }
  ngOnDestroy(): void {
    this.mapService.removeOldMap();
  }
  ngAfterViewInit(): void {
    this.currentUserService.currentUser.subscribe((user: any) => {
      const userId = user.id;

      this.dataService
        .getContentDetailsByUserId(userId, this.contentId)
        .subscribe((data: any) => {
          if (data.res) {
            this.contentData = data.res;

            this.mapService.map.setTarget(
              this.elementRefTwo.nativeElement.querySelector('#map'),
            );
            this.mapService.loadlayers({
              map_id: this.mapCode ? this.mapCode : '000085',
              type: 'Master',
            });
            this.coordsPass = this.contentData.coordslocationarr;
            this.mapService.addStaticPoint(this.coordsPass);
            this.cdr.detectChanges();
          }
        });
    });
  }

  ngOnInit(): void {
    this.contentId = this.activatedRoute.snapshot.queryParamMap.get('id');
    this.mapCode = this.activatedRoute.snapshot.queryParamMap.get('mapcode');
    this.router.navigate(['/content-creator-detail'], {
      queryParams: { mode: 'edit', id: this.contentId, mapcode: this.mapCode },
    });
    this.router.events.subscribe((event: any) => {
      this.params = this.activatedRoute.snapshot.queryParamMap.get('mode');
      this.mapService.layerContentPinLayer.getSource().clear();
    
          this.cdr.detectChanges();});
  }

  uploadGameImage() { }

  handleGameChangeImg(event) {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        this.selectedGameImage = reader.result;
        this.creatorDetailsForm
          .get('gameImage')
          .setValue(this.selectedGameImage);
        this.creatorDetailsForm.controls['gameImage'].setErrors(null);
        this.creatorDetailsForm.updateValueAndValidity();
      
          this.cdr.detectChanges();};
      reader.readAsDataURL(file);
    }
  }

  handleCreatorImages(event) {
    const file = event.target.files[0];

    const reader = new FileReader();
    reader.onloadend = () => {
      this.contentImgArr.push(reader.result);
      this.creatorDetailsForm.get('contentImgArr').setValue(this.contentImgArr);
      if (this.contentImgArr.length == 2) {
        this.uploadContainerHeight = this.contentImgArr.length * 250 + 'px';
      } else if (this.contentImgArr.length == 4) {
        this.uploadContainerHeight = this.contentImgArr.length * 200 + 'px';
      } else {
        this.uploadContainerHeight = this.uploadContainerHeight;
      }
      this.creatorDetailsForm.controls['contentImgArr'].setErrors(null);
      this.creatorDetailsForm.updateValueAndValidity();
    
          this.cdr.detectChanges();};
    reader.readAsDataURL(file);
  }

  handleFormSubmit() {
  }
}
